import { Component } from "@angular/core";
import { UiMessageService } from "@webapp/ui/message/services/message.service";
import { concatMap } from "rxjs";

@Component({
  selector: "gh-example-messages-component",
  templateUrl: "./example-messages.component.html",
  styleUrls: [],
})
export class ExampleMessagesComponent {
  public constructor(private messageService: UiMessageService) {}

  public createBasicMessage(): void {
    this.messageService.info("This is a normal message");
  }

  public createMessage(type: string): void {
    this.messageService.create(type, `This is a message of ${type}`);
  }

  public startShowMessages(): void {
    this.messageService
      .loading("Action in progress", { nzDuration: 2500 })
      .onClose!.pipe(
        concatMap(() => this.messageService.success("Loading finished", { nzDuration: 2500 }).onClose!),
        concatMap(() => this.messageService.info("Loading finished is finished", { nzDuration: 2500 }).onClose!)
      )
      .subscribe(() => {
        // eslint-disable-next-line no-console
        console.log("All completed!");
      });
  }
}
